import LogRocket from 'logrocket'
import { useEffect, useState } from 'react'

import { Modal, OlarkChat } from '@fv/client-components'
import { logrocketApp } from '@fv/client-core'

import { CarrierRoutes } from './CarrierRoutes'
import { adminUri } from './constants'
import { AppLayout } from './features/layout/AppLayout'
import { ProfileModalView } from './features/profile/ProfileModalView'
import { useUserContext } from './hooks/settings'

export const AuthenticatedApp = () => {
  const context = useUserContext()
  const [hasProfile, setHasProfile] = useState(true)
  const { _id: userId, carrierId, email, profile } = context.data?.user ?? {}
  const { firstName, lastName, role } = profile ?? {}

  useEffect(() => {
    if (context.isLoading) return
    setHasProfile(
      Boolean(firstName?.trim() && lastName?.trim() && role?.trim()),
    )
  }, [context.isLoading, firstName, lastName, role])

  useEffect(() => {
    if (!logrocketApp) return

    const name = `${firstName ?? ''} ${lastName ?? ''}`.trim()

    LogRocket.identify(userId, {
      ...(carrierId && { carrierId }),
      email,
      ...(name && { name }),
    })
  }, [carrierId, email, firstName, lastName, userId])

  return (
    <>
      <AppLayout>
        <CarrierRoutes carrierId={carrierId} />
      </AppLayout>

      {!hasProfile && (
        <Modal>
          <ProfileModalView />
        </Modal>
      )}
      <OlarkChat
        carrierId={carrierId}
        email={email}
        linkLabel="View as customer"
        name={
          firstName && lastName ? `${firstName} ${lastName}` : 'Unknown user'
        }
        userId={userId}
        viewAsLink={`${adminUri}/search/${userId}`}
      />
    </>
  )
}
